// external modules
import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import i18next from "i18next";

import Footer from "./Common/Components/Footer";
import Navbar from "./Common/Components/Navbar";
import { LANGUAGES } from "./Common/constants";

import { I18N_NAVIGATION_ROUTES } from "./Navigation";
import { useTranslation } from "react-i18next";

const isSupportedLang = (lang) => {
  return lang === "en" || lang === "ms";
};

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(["routes"]);

  useEffect(() => {
    const slugs = location.pathname.split("/").filter((item) => item !== "");
    const storedLang = localStorage.getItem("i18nextLng");
    let currentLanguage = "en";

    if (isSupportedLang(slugs?.[0])) {
      currentLanguage = slugs[0];
    } else if (isSupportedLang(storedLang)) {
      currentLanguage = storedLang;
    }

    i18next.changeLanguage(currentLanguage);

    if (!isSupportedLang(slugs?.[0])) {
      const restPath = slugs
        .filter((item) => !["en", "ms", "my"].includes(item))
        .join("/");

      window.location.replace(`/${currentLanguage}/${restPath}`);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate(`/${i18n.language}`, { replace: true });
    }
  }, []);

  const ROUTES = I18N_NAVIGATION_ROUTES(t, i18n.language);

  const LANGUAGE_ROUTES = LANGUAGES.flatMap((item) => {
    return Object.values(ROUTES).map((route) => ({
      ...route,
      path: `/${item}${route.path}`,
    }));
  });

  return (
    <>
      <Navbar />
      <Routes>
        {Object.values(ROUTES).map((route, idx) => (
          <Route key={`${idx}`} {...route} />
        ))}
        {Object.values(LANGUAGE_ROUTES).map((route, idx) => (
          <Route key={`${idx}-${route.path}`} {...route} />
        ))}
      </Routes>
      <Footer />
    </>
  );
};

export default App;
